<template>
	<div :class="$style['CPS-store-message']">
		<div :class="$style['store-message-left']">
			<table>
        <tr>
            <td>合同号：</td>
            <td>{{orderDetail.contractNumber}}</td>
        </tr>
				<tr>
            <td>存储公司：</td>
            <td>{{vendorInfo.storageAreaName}}</td>
        </tr>
				<tr>
            <td>结算公司：</td>
            <td>{{vendorInfo.balanceOrgName}}</td>
        </tr>
				<tr>
            <td>孩子生日：</td>
            <td>{{extendInfo.child_birthday}}</td>
        </tr>
			</table>	
		</div>
		<div>
			<table>
				<tr>
					<td>采集时间：</td>
					<td>{{ extendInfo.collect_time }}</td>
				</tr>
				<tr>
					<td>医院名称：</td>
					<td>{{ extendInfo.hospitalName }}</td>
				</tr>
				<tr>
					<td>医院代码：</td>
					<td>{{ extendInfo.hospitalCode }}</td>
				</tr>
				<tr>
					<td>存储状态：</td>
					<td>{{orderDetail.thirdStatus+''+(orderDetail.third_status?('('+orderDetail.third_status+')'):'')}}</td>
				</tr>
			</table>
		</div>
	</div>
</template>
<script>
export default {
	props:{
		orderDetail:Object,
		goodsData:Object
	},
	computed:{
		extendInfo(){
			return this.orderDetail.extendInfo||{}
		},
		vendorInfo(){
		return this.goodsData.vendorInfo||{}
	}
	}
}
</script>
<style module lang="less">
@import "~less/var.less";
.CPS-store-message{
	padding:0 20px;
	display: flex;
	flex-direction: row;
	:global
    table{
        border: none;
        border-spacing:0;
        tr{
            td{
                line-height: 30px;
                font-size: 14px;
            }
            :first-child{
                display: flex;
                color:@mainColor;
                justify-content: flex-end;
                white-space:nowrap
            }
            .goods-order-status{
                color: @mainColor;
                font-size: 16px;
                font-weight: 600;
                div{
                    display: inline-block;
                    margin-left: 5px;
                    i{
                        color: #56575B
                    }
                }
            }
        }
    }
}
.store-message-left{
	width: 50%;
}
</style>